import { render, staticRenderFns } from "./LikeDislikeBtn.vue?vue&type=template&id=13cf4456&scoped=true"
import script from "./LikeDislikeBtn.vue?vue&type=script&lang=ts"
export * from "./LikeDislikeBtn.vue?vue&type=script&lang=ts"
import style0 from "./LikeDislikeBtn.vue?vue&type=style&index=0&id=13cf4456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cf4456",
  null
  
)

export default component.exports